import React from 'react';
import { stats } from '../mockData';

const WhyChooseUs = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Choose Us As?
            </h2>
            <p className="text-3xl text-gray-900 font-semibold">
              Your Trusted Property Consultants
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-100 hover:border-[#B8944A] transition-all">
              <div className="text-5xl font-bold text-[#B8944A] mb-4">40+</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Years of Experience</h3>
              <p className="text-gray-600 leading-relaxed">
                Based in the city for over 40 years, Bhagat Prop Built has established itself as a reputable name in the real estate sector. Our team of expert property consultants is dedicated to providing outstanding service.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-100 hover:border-[#B8944A] transition-all">
              <div className="text-5xl font-bold text-[#B8944A] mb-4">10000+</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Satisfied Clients</h3>
              <p className="text-gray-600 leading-relaxed">
                As your trusted real estate consultants, Bhagat Prop Built has helped 10,000+ customers find homes, properties, investments, and commercial spaces, earning their trust and satisfaction.
              </p>
            </div>
          </div>

          {/* Image with Description */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Our Expertise As<br />
              Real Estate Consultants
            </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <strong>Expert Guidance You Can Trust.</strong>
              </p>
              <p className="text-gray-600 leading-relaxed mb-6">
                Bhagat Prop Built, your trusted real estate consultants, connects you to the greatest real estate opportunities. From ideal plots for your dream home to ready-to-move residences and commercial spaces, we have you covered.
              </p>
              <p className="text-gray-600 leading-relaxed">
                With in-depth local knowledge, our team of experienced real estate consultants tailors options to your specific needs. Trust Bhagat Prop Built for smart investments and excellent service. We are dedicated to turning your real estate dreams into reality with transparency and expertise.
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab"
                alt="Real Estate Expertise"
                className="w-full h-[500px] object-cover rounded-xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;